export const OPEN_INTERNAL_WORKSPACE = 'OPEN_INTERNAL_WORKSPACE';
export const openInternalWorkspace = (activeTab = 'notes') => ({
	type: OPEN_INTERNAL_WORKSPACE,
	activeTab,
});

export const CLOSE_INTERNAL_WORKSPACE = 'CLOSE_INTERNAL_WORKSPACE';
export const closeInternalWorkspace = () => ({
	type: CLOSE_INTERNAL_WORKSPACE,
});
